define([
	"dojo/_base/declare",
	"csi/table/Delete",
	"csi/xml"
], function(declare,Delete,xml) {

	return declare(Delete, {
		toWriterRequest: function(/*FormData?*/fd) {
			// summary: pass template revision as parent URL rather than node where action invoked
			return this._writeRequest()
				.addParameter(xml.PROP_URL_PARENT, xml.ATTR_REF, this.widget._getViewNode().$URL)
				.addParameter(xml.PROP_AGGREGATE_REMOVES, xml.ATTR_REFLIST, [this.m_urlNode]);
		},

		postProcessSuccess: function() {
			// summary: refresh parent rows to update point totals
			this.widget.resetPoints();
			this.widget.refreshWidget(); //DE28105
			return this.inherited(arguments);
		}
	});
});